<template>
  <main class="ohs-main">
    <slot></slot>
  </main>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.ohs-main {
  min-height: calc(100vh - 100px);
}
</style>
